import { SvgIcon } from '@mui/material';
import { ThemeContext } from 'styled-components';
import { useContext } from 'react';

function Chevron(props: any) {
  const tempUuid = 'uuid';
  const maskid = 'maskid';
  const themeContext = useContext(ThemeContext);

  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 8 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <path
            d="M14.0018124,6.0037345 L15.0624726,7.06439467 L10.6571973,11.4696699 C10.3643041,11.7625631 10.3643041,12.2374369 10.6571973,12.5303301 L15.0624726,16.9356053 L14.0018124,17.9962655 L9.59653716,13.5909903 C8.71785751,12.7123106 8.71785751,11.2876894 9.59653716,10.4090097 L14.0018124,6.0037345 Z"
            id={tempUuid}
          />
        </defs>
        <g
          id="RBAAS---Admin"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Admin---B---003-&gt;-Find-a-Rubric-&gt;-Expanded"
            transform="translate(-156.000000, -608.000000)"
          >
            <g id="Rubrics" transform="translate(124.000000, 170.000000)">
              <g id="Row-7" transform="translate(0.000000, 419.999706)">
                <g id="Chevron" transform="translate(24.000000, 12.000000)">
                  <mask id={maskid} fill="white">
                    <use xlinkHref={`#${tempUuid}`} />
                  </mask>
                  <g
                    id="Path"
                    fillRule="nonzero"
                    transform="translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
                  />
                  <g id="↳-Icon-Color" mask={`url(#${maskid})`} fill={themeContext.colors.black[54]}>
                    <rect id="Rectangle" x="0" y="0" width="24" height="24" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}

function PermIdentity(props: any) {
  const themeContext = useContext(ThemeContext);

  return (
    <SvgIcon {...props}>
      <svg
        width="16px"
        height="17px"
        style={{
          paddingTop: '6px',
        }}
        viewBox="0 0 16 17"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xlinkHref="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path
            d="M5.5,19.625 L4,19.625 C4,16.3013079 5.96081379,14.269738 9.56205038,13.1188158 C9.58144169,13.1126127 9.59889809,13.0880399 9.5988125,13.0537813 C9.5988125,13.0277488 9.58925474,13.0100011 9.58366479,13.0065864 C8.20567676,12.1678111 7.345875,10.6721945 7.345875,9.029125 C7.345875,6.4583225 9.42953158,4.375 12,4.375 C14.5704684,4.375 16.654125,6.4583225 16.654125,9.029125 C16.654125,10.6721945 15.7943232,12.1678111 14.4172648,13.0060196 C14.4107453,13.0100011 14.4011875,13.0277488 14.401185,13.0557093 C14.4011017,13.0881206 14.4187092,13.1129348 14.4367837,13.1187328 C18.0389734,14.2696029 20,16.301136 20,19.625 L18.5,19.625 C18.5,17.0509784 17.0213664,15.5191822 13.9794606,14.5473177 C13.3315112,14.3394849 12.8994452,13.7305733 12.9011875,13.0537813 C12.9011875,12.5145379 13.174222,12.0075428 13.6364148,11.7252886 C14.5718842,11.1558724 15.154125,10.1430703 15.154125,9.029125 C15.154125,7.28680347 13.7420951,5.875 12,5.875 C10.2579049,5.875 8.845875,7.28680347 8.845875,9.029125 C8.845875,10.1430703 9.42811583,11.1558724 10.3645148,11.7258554 C10.825778,12.0075428 11.0988125,12.5145379 11.09881,13.0518532 C11.1005559,13.7310161 10.6679998,14.3399104 10.0188791,14.5475592 C6.9784944,15.5192382 5.5,17.0510842 5.5,19.625 Z"
            id="path-1"
          />
        </defs>
        <g
          id="In-Progress"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="RBAAS---Admin---A---001-&gt;-Side-Navigation"
            transform="translate(-1244.000000, -19.000000)"
          >
            <g id="App-Bar">
              <g
                id="Perm-Identity"
                transform="translate(1240.000000, 15.500000)"
              >
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1" />
                </mask>
                <g id="Path" fillRule="nonzero" />
                <g id="↳-Icon-Color" mask="url(#mask-2)" fill={themeContext.colors.white}>
                  <rect id="Rectangle" x="0" y="0" width="24" height="24" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}

function MousePointerIllustration() {
  const tempUuid = 'mouse-temp-uuid';
  const maskid = 'maskid-mouse';
  const themeContext = useContext(ThemeContext);

  return (
    <svg
      width="130px"
      height="180px"
      viewBox="0 0 130 180"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>8BFCF391-CA82-42C8-971C-F833D664B29F</title>
      <desc>Created with sketchtool.</desc>
      <defs>
        <circle id={tempUuid} cx="37" cy="37" r="37" />
      </defs>
      <g
        id="In-Progress"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Admin---A---003-&gt;-Find-an-Assessment-&gt;-Dropdown"
          transform="translate(-575.000000, -382.000000)"
        >
          <g id="Assessments" transform="translate(124.000000, 170.000000)">
            <g
              id="Search-Illustration"
              transform="translate(416.000000, 212.000000)"
            >
              <g id="Circle" transform="translate(90.999973, 106.000000)">
                <mask id={maskid} fill="white">
                  <use xlinkHref={`#${tempUuid}`} />
                </mask>
                <use id="Oval" fill={themeContext.colors.white} xlinkHref={`#${tempUuid}`} />
                <g id="Dots" mask={`url(#${maskid})`} fill={themeContext.colors.primaryShades[300]}>
                  <g transform="translate(-43.500000, -43.500000)">
                    <circle id="Oval" cx="10.8652344" cy="10.67705" r="1.5" />
                    <circle
                      id="Oval-Copy-612"
                      cx="1.86523438"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-578"
                      cx="10.8652344"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-613"
                      cx="1.86523438"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-256"
                      cx="10.8652344"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-614"
                      cx="1.86523438"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-128"
                      cx="82.8652344"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-579"
                      cx="82.8652344"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-257"
                      cx="82.8652344"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-64"
                      cx="46.8652344"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-580"
                      cx="46.8652344"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-258"
                      cx="46.8652344"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-129"
                      cx="118.865234"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-581"
                      cx="118.865234"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-259"
                      cx="118.865234"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-32"
                      cx="10.8652344"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-615"
                      cx="1.86523438"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-260"
                      cx="10.8652344"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-616"
                      cx="1.86523438"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-130"
                      cx="82.8652344"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-261"
                      cx="82.8652344"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-65"
                      cx="46.8652344"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-262"
                      cx="46.8652344"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-131"
                      cx="118.865234"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-263"
                      cx="118.865234"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-16"
                      cx="28.8652344"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-582"
                      cx="28.8652344"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-264"
                      cx="28.8652344"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-132"
                      cx="100.865234"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-583"
                      cx="100.865234"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-265"
                      cx="100.865234"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-66"
                      cx="64.8652344"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-584"
                      cx="64.8652344"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-266"
                      cx="64.8652344"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-33"
                      cx="28.8652344"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-268"
                      cx="28.8652344"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-134"
                      cx="100.865234"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-269"
                      cx="100.865234"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-67"
                      cx="64.8652344"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-270"
                      cx="64.8652344"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-8"
                      cx="19.8652344"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-586"
                      cx="19.8652344"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-272"
                      cx="19.8652344"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-136"
                      cx="91.8652344"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-587"
                      cx="91.8652344"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-273"
                      cx="91.8652344"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-68"
                      cx="55.8652344"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-588"
                      cx="55.8652344"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-274"
                      cx="55.8652344"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-34"
                      cx="19.8652344"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-276"
                      cx="19.8652344"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-138"
                      cx="91.8652344"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-277"
                      cx="91.8652344"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-69"
                      cx="55.8652344"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-278"
                      cx="55.8652344"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-17"
                      cx="37.8652344"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-590"
                      cx="37.8652344"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-280"
                      cx="37.8652344"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-140"
                      cx="109.865234"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-591"
                      cx="109.865234"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-281"
                      cx="109.865234"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-70"
                      cx="73.8652344"
                      cy="10.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-592"
                      cx="73.8652344"
                      cy="1.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-282"
                      cx="73.8652344"
                      cy="82.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-35"
                      cx="37.8652344"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-284"
                      cx="37.8652344"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-142"
                      cx="109.865234"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-285"
                      cx="109.865234"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-71"
                      cx="73.8652344"
                      cy="46.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-286"
                      cx="73.8652344"
                      cy="118.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-4"
                      cx="15.3652344"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-617"
                      cx="6.36523438"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-595"
                      cx="15.3652344"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-618"
                      cx="6.36523438"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-288"
                      cx="15.3652344"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-619"
                      cx="6.36523438"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-144"
                      cx="87.3652344"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-596"
                      cx="87.3652344"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-289"
                      cx="87.3652344"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-72"
                      cx="51.3652344"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-597"
                      cx="51.3652344"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-290"
                      cx="51.3652344"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-36"
                      cx="15.3652344"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-620"
                      cx="6.36523438"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-146"
                      cx="87.3652344"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-73"
                      cx="51.3652344"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-18"
                      cx="33.3652344"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-599"
                      cx="33.3652344"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-296"
                      cx="33.3652344"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-148"
                      cx="105.365234"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-600"
                      cx="105.365234"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-297"
                      cx="105.365234"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-74"
                      cx="69.3652344"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-601"
                      cx="69.3652344"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-298"
                      cx="69.3652344"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-37"
                      cx="33.3652344"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-150"
                      cx="105.365234"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-75"
                      cx="69.3652344"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-9"
                      cx="24.3652344"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-603"
                      cx="24.3652344"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-304"
                      cx="24.3652344"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-152"
                      cx="96.3652344"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-604"
                      cx="96.3652344"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-305"
                      cx="96.3652344"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-76"
                      cx="60.3652344"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-605"
                      cx="60.3652344"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-306"
                      cx="60.3652344"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-38"
                      cx="24.3652344"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-154"
                      cx="96.3652344"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-77"
                      cx="60.3652344"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-19"
                      cx="42.3652344"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-607"
                      cx="42.3652344"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-312"
                      cx="42.3652344"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-156"
                      cx="114.365234"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-608"
                      cx="114.365234"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-313"
                      cx="114.365234"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-78"
                      cx="78.3652344"
                      cy="15.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-609"
                      cx="78.3652344"
                      cy="6.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-314"
                      cx="78.3652344"
                      cy="87.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-39"
                      cx="42.3652344"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-158"
                      cx="114.365234"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-79"
                      cx="78.3652344"
                      cy="51.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-2"
                      cx="10.8652344"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-622"
                      cx="1.86523438"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-320"
                      cx="10.8652344"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-623"
                      cx="1.86523438"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-160"
                      cx="82.8652344"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-321"
                      cx="82.8652344"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-80"
                      cx="46.8652344"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-322"
                      cx="46.8652344"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-161"
                      cx="118.865234"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-323"
                      cx="118.865234"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-40"
                      cx="10.8652344"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-624"
                      cx="1.86523438"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-162"
                      cx="82.8652344"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-81"
                      cx="46.8652344"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-163"
                      cx="118.865234"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-20"
                      cx="28.8652344"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-328"
                      cx="28.8652344"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-164"
                      cx="100.865234"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-329"
                      cx="100.865234"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-82"
                      cx="64.8652344"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-330"
                      cx="64.8652344"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-41"
                      cx="28.8652344"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-166"
                      cx="100.865234"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-83"
                      cx="64.8652344"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-10"
                      cx="19.8652344"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-336"
                      cx="19.8652344"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-168"
                      cx="91.8652344"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-337"
                      cx="91.8652344"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-84"
                      cx="55.8652344"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-338"
                      cx="55.8652344"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-42"
                      cx="19.8652344"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-170"
                      cx="91.8652344"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-85"
                      cx="55.8652344"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-21"
                      cx="37.8652344"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-344"
                      cx="37.8652344"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-172"
                      cx="109.865234"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-345"
                      cx="109.865234"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-86"
                      cx="73.8652344"
                      cy="28.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-346"
                      cx="73.8652344"
                      cy="100.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-43"
                      cx="37.8652344"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-174"
                      cx="109.865234"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-87"
                      cx="73.8652344"
                      cy="64.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-5"
                      cx="15.3652344"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-626"
                      cx="6.36523438"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-352"
                      cx="15.3652344"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-627"
                      cx="6.36523438"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-176"
                      cx="87.3652344"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-353"
                      cx="87.3652344"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-88"
                      cx="51.3652344"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-354"
                      cx="51.3652344"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-44"
                      cx="15.3652344"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-628"
                      cx="6.36523438"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-178"
                      cx="87.3652344"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-89"
                      cx="51.3652344"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-22"
                      cx="33.3652344"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-360"
                      cx="33.3652344"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-180"
                      cx="105.365234"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-361"
                      cx="105.365234"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-90"
                      cx="69.3652344"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-362"
                      cx="69.3652344"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-45"
                      cx="33.3652344"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-182"
                      cx="105.365234"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-91"
                      cx="69.3652344"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-11"
                      cx="24.3652344"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-368"
                      cx="24.3652344"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-184"
                      cx="96.3652344"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-369"
                      cx="96.3652344"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-92"
                      cx="60.3652344"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-370"
                      cx="60.3652344"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-46"
                      cx="24.3652344"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-186"
                      cx="96.3652344"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-93"
                      cx="60.3652344"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-23"
                      cx="42.3652344"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-376"
                      cx="42.3652344"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-188"
                      cx="114.365234"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-377"
                      cx="114.365234"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-94"
                      cx="78.3652344"
                      cy="33.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-378"
                      cx="78.3652344"
                      cy="105.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-47"
                      cx="42.3652344"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-190"
                      cx="114.365234"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-95"
                      cx="78.3652344"
                      cy="69.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy"
                      cx="10.8652344"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-630"
                      cx="1.86523438"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-384"
                      cx="10.8652344"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-631"
                      cx="1.86523438"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-192"
                      cx="82.8652344"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-385"
                      cx="82.8652344"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-96"
                      cx="46.8652344"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-386"
                      cx="46.8652344"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-193"
                      cx="118.865234"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-387"
                      cx="118.865234"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-48"
                      cx="10.8652344"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-632"
                      cx="1.86523438"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-194"
                      cx="82.8652344"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-97"
                      cx="46.8652344"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-195"
                      cx="118.865234"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-24"
                      cx="28.8652344"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-392"
                      cx="28.8652344"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-196"
                      cx="100.865234"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-393"
                      cx="100.865234"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-98"
                      cx="64.8652344"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-394"
                      cx="64.8652344"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-49"
                      cx="28.8652344"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-198"
                      cx="100.865234"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-99"
                      cx="64.8652344"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-12"
                      cx="19.8652344"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-400"
                      cx="19.8652344"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-200"
                      cx="91.8652344"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-401"
                      cx="91.8652344"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-100"
                      cx="55.8652344"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-402"
                      cx="55.8652344"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-50"
                      cx="19.8652344"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-202"
                      cx="91.8652344"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-101"
                      cx="55.8652344"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-25"
                      cx="37.8652344"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-408"
                      cx="37.8652344"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-204"
                      cx="109.865234"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-409"
                      cx="109.865234"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-102"
                      cx="73.8652344"
                      cy="19.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-410"
                      cx="73.8652344"
                      cy="91.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-51"
                      cx="37.8652344"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-206"
                      cx="109.865234"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-103"
                      cx="73.8652344"
                      cy="55.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-6"
                      cx="15.3652344"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-634"
                      cx="6.36523438"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-416"
                      cx="15.3652344"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-635"
                      cx="6.36523438"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-208"
                      cx="87.3652344"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-417"
                      cx="87.3652344"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-104"
                      cx="51.3652344"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-418"
                      cx="51.3652344"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-52"
                      cx="15.3652344"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-636"
                      cx="6.36523438"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-210"
                      cx="87.3652344"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-105"
                      cx="51.3652344"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-26"
                      cx="33.3652344"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-424"
                      cx="33.3652344"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-212"
                      cx="105.365234"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-425"
                      cx="105.365234"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-106"
                      cx="69.3652344"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-426"
                      cx="69.3652344"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-53"
                      cx="33.3652344"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-214"
                      cx="105.365234"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-107"
                      cx="69.3652344"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-13"
                      cx="24.3652344"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-432"
                      cx="24.3652344"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-216"
                      cx="96.3652344"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-433"
                      cx="96.3652344"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-108"
                      cx="60.3652344"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-434"
                      cx="60.3652344"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-54"
                      cx="24.3652344"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-218"
                      cx="96.3652344"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-109"
                      cx="60.3652344"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-27"
                      cx="42.3652344"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-440"
                      cx="42.3652344"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-220"
                      cx="114.365234"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-441"
                      cx="114.365234"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-110"
                      cx="78.3652344"
                      cy="24.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-442"
                      cx="78.3652344"
                      cy="96.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-55"
                      cx="42.3652344"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-222"
                      cx="114.365234"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-111"
                      cx="78.3652344"
                      cy="60.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-3"
                      cx="10.8652344"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-638"
                      cx="1.86523438"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-448"
                      cx="10.8652344"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-639"
                      cx="1.86523438"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-224"
                      cx="82.8652344"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-449"
                      cx="82.8652344"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-112"
                      cx="46.8652344"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-450"
                      cx="46.8652344"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-225"
                      cx="118.865234"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-451"
                      cx="118.865234"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-56"
                      cx="10.8652344"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-640"
                      cx="1.86523438"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-226"
                      cx="82.8652344"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-113"
                      cx="46.8652344"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-227"
                      cx="118.865234"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-28"
                      cx="28.8652344"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-456"
                      cx="28.8652344"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-228"
                      cx="100.865234"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-457"
                      cx="100.865234"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-114"
                      cx="64.8652344"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-458"
                      cx="64.8652344"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-57"
                      cx="28.8652344"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-230"
                      cx="100.865234"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-115"
                      cx="64.8652344"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-14"
                      cx="19.8652344"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-464"
                      cx="19.8652344"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-232"
                      cx="91.8652344"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-465"
                      cx="91.8652344"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-116"
                      cx="55.8652344"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-466"
                      cx="55.8652344"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-58"
                      cx="19.8652344"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-234"
                      cx="91.8652344"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-117"
                      cx="55.8652344"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-29"
                      cx="37.8652344"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-472"
                      cx="37.8652344"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-236"
                      cx="109.865234"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-473"
                      cx="109.865234"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-118"
                      cx="73.8652344"
                      cy="37.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-474"
                      cx="73.8652344"
                      cy="109.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-59"
                      cx="37.8652344"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-238"
                      cx="109.865234"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-119"
                      cx="73.8652344"
                      cy="73.67705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-7"
                      cx="15.3652344"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-643"
                      cx="6.36523438"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-480"
                      cx="15.3652344"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-644"
                      cx="6.36523438"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-240"
                      cx="87.3652344"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-481"
                      cx="87.3652344"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-120"
                      cx="51.3652344"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-482"
                      cx="51.3652344"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-60"
                      cx="15.3652344"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-645"
                      cx="6.36523438"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-242"
                      cx="87.3652344"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-121"
                      cx="51.3652344"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-30"
                      cx="33.3652344"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-488"
                      cx="33.3652344"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-244"
                      cx="105.365234"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-489"
                      cx="105.365234"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-122"
                      cx="69.3652344"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-490"
                      cx="69.3652344"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-61"
                      cx="33.3652344"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-246"
                      cx="105.365234"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-123"
                      cx="69.3652344"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-15"
                      cx="24.3652344"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-496"
                      cx="24.3652344"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-248"
                      cx="96.3652344"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-497"
                      cx="96.3652344"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-124"
                      cx="60.3652344"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-498"
                      cx="60.3652344"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-62"
                      cx="24.3652344"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-250"
                      cx="96.3652344"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-125"
                      cx="60.3652344"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-31"
                      cx="42.3652344"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-504"
                      cx="42.3652344"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-252"
                      cx="114.365234"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-505"
                      cx="114.365234"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-126"
                      cx="78.3652344"
                      cy="42.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-506"
                      cx="78.3652344"
                      cy="114.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-63"
                      cx="42.3652344"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-254"
                      cx="114.365234"
                      cy="78.17705"
                      r="1.5"
                    />
                    <circle
                      id="Oval-Copy-127"
                      cx="78.3652344"
                      cy="78.17705"
                      r="1.5"
                    />
                  </g>
                </g>
              </g>
              <path
                d="M59.1769135,139.293339 C57.5387782,140.721187 55.0533078,140.550716 53.62546,138.91258 C53.1047997,138.315239 52.7766276,137.574611 52.6839044,136.787652 L38.0274102,12.3951231 C37.7731281,10.236981 39.3165115,8.28132479 41.4746536,8.02704266 C42.474205,7.90927096 43.4808862,8.17901037 44.2876373,8.78077935 L144.68648,83.6699399 C146.428345,84.9692257 146.787126,87.4345654 145.48784,89.1764303 C145.014059,89.8115959 144.35954,90.2889123 143.609965,90.5458946 L113.222758,100.963758 C112.734442,101.131171 112.474298,101.662744 112.641711,102.15106 C112.66126,102.20808 112.686278,102.263076 112.716418,102.315278 L135.584579,141.924095 C136.671114,143.80603 136.026316,146.21245 134.144381,147.298985 L113.059324,159.472449 C111.177389,160.558985 108.770969,159.914186 107.684433,158.032252 L84.8162723,118.423435 C84.558164,117.976378 83.9865149,117.823205 83.5394582,118.081313 C83.4872557,118.111453 83.438091,118.146571 83.3926511,118.186178 L59.1769135,139.293339 Z"
                id="Path"
                fill={themeContext.colors.primaryShades[100]}
                fillRule="nonzero"
              />
              <path
                d="M79.0394582,107.483237 C80.9213927,106.396702 83.3278131,107.0415 84.4143485,108.923435 L107.28251,148.532252 C107.540618,148.979308 108.112267,149.132481 108.559324,148.874373 L129.644381,136.700909 C130.091438,136.442801 130.244611,135.871152 129.986503,135.424095 L107.118341,95.8152783 C106.991467,95.5955258 106.886148,95.3640155 106.803856,95.1239819 C106.099113,93.0683618 107.194215,90.8306454 109.249835,90.1259025 L139.637042,79.7080394 C139.815105,79.6469928 139.970588,79.5336055 140.083135,79.3827209 C140.391782,78.968938 140.306553,78.3832925 139.89277,78.074645 L39.4939279,3.18548445 C39.3022828,3.04253324 39.063144,2.9784562 38.825699,3.00643306 C38.3130288,3.0668382 37.9463955,3.53140756 38.0068006,4.04407777 L52.6632948,128.436606 C52.6853214,128.62355 52.7632792,128.799487 52.8869629,128.941387 C53.2261505,129.330528 53.8165781,129.371024 54.2057198,129.031837 L78.4214575,107.924675 C78.6127416,107.757946 78.8197057,107.610111 79.0394582,107.483237 Z M56.1769135,131.293339 C54.5387782,132.721187 52.0533078,132.550716 50.62546,130.91258 C50.1047997,130.315239 49.7766276,129.574611 49.6839044,128.787652 L35.0274102,4.39512311 C34.7731281,2.23698102 36.3165115,0.281324788 38.4746536,0.0270426573 C39.474205,-0.0907290406 40.4808862,0.179010369 41.2876373,0.78077935 L141.68648,75.6699399 C143.428345,76.9692257 143.787126,79.4345654 142.48784,81.1764303 C142.014059,81.8115959 141.35954,82.2889123 140.609965,82.5458946 L110.222758,92.9637577 C109.734442,93.1311706 109.474298,93.6627438 109.641711,94.1510597 C109.66126,94.2080801 109.686278,94.2630758 109.716418,94.3152783 L132.584579,133.924095 C133.671114,135.80603 133.026316,138.21245 131.144381,139.298985 L110.059324,151.472449 C108.177389,152.558985 105.770969,151.914186 104.684433,150.032252 L81.8162723,110.423435 C81.558164,109.976378 80.9865149,109.823205 80.5394582,110.081313 C80.4872557,110.111453 80.438091,110.146571 80.3926511,110.186178 L56.1769135,131.293339 Z"
                id="Rectangle"
                fill={themeContext.colors.primaryShades[600]}
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

const WelcomeBack = () => {
  const themeContext = useContext(ThemeContext);

  return (
    <svg
      width="200px"
      height="180px"
      viewBox="0 0 200 180"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink"
    >
      <defs>
        <circle id="circles" cx="78" cy="78" r="78" />
      </defs>
      <g
        id="In-Progress"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="RBAAS---Admin---A---001-&gt;-Side-Navigation"
          transform="translate(-666.000000, -256.000000)"
        >
          <g
            id="Welcome-Back-Illustration"
            transform="translate(666.000000, 256.000000)"
          >
            <g id="Circle" transform="translate(44.000000, 0.000000)">
              <mask id="circle-mask" fill="white">
                <use xlinkHref="#circles" />
              </mask>
              <use id="Oval" fill={themeContext.colors.white} xlinkHref="#circles" />
              <g id="Dots" mask="url(#circle-mask)" fill={themeContext.colors.primaryShades[300]}>
                <g transform="translate(-3.000000, -2.000000)">
                  <circle id="Oval" cx="10.8652344" cy="10.67705" r="1.5" />
                  <circle
                    id="Oval-Copy-612"
                    cx="1.86523438"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-578"
                    cx="10.8652344"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-613"
                    cx="1.86523438"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-256"
                    cx="10.8652344"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-614"
                    cx="1.86523438"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-128"
                    cx="82.8652344"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-579"
                    cx="82.8652344"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-257"
                    cx="82.8652344"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-64"
                    cx="46.8652344"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-580"
                    cx="46.8652344"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-258"
                    cx="46.8652344"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-129"
                    cx="118.865234"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-581"
                    cx="118.865234"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-259"
                    cx="118.865234"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-32"
                    cx="10.8652344"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-615"
                    cx="1.86523438"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-260"
                    cx="10.8652344"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-616"
                    cx="1.86523438"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-130"
                    cx="82.8652344"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-261"
                    cx="82.8652344"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-65"
                    cx="46.8652344"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-262"
                    cx="46.8652344"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-131"
                    cx="118.865234"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-263"
                    cx="118.865234"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-16"
                    cx="28.8652344"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-582"
                    cx="28.8652344"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-264"
                    cx="28.8652344"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-132"
                    cx="100.865234"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-583"
                    cx="100.865234"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-265"
                    cx="100.865234"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-66"
                    cx="64.8652344"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-584"
                    cx="64.8652344"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-266"
                    cx="64.8652344"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-133"
                    cx="136.865234"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-585"
                    cx="136.865234"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-267"
                    cx="136.865234"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-33"
                    cx="28.8652344"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-268"
                    cx="28.8652344"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-134"
                    cx="100.865234"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-269"
                    cx="100.865234"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-67"
                    cx="64.8652344"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-270"
                    cx="64.8652344"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-135"
                    cx="136.865234"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-271"
                    cx="136.865234"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-8"
                    cx="19.8652344"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-586"
                    cx="19.8652344"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-272"
                    cx="19.8652344"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-136"
                    cx="91.8652344"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-587"
                    cx="91.8652344"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-273"
                    cx="91.8652344"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-68"
                    cx="55.8652344"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-588"
                    cx="55.8652344"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-274"
                    cx="55.8652344"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-137"
                    cx="127.865234"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-589"
                    cx="127.865234"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-275"
                    cx="127.865234"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-34"
                    cx="19.8652344"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-276"
                    cx="19.8652344"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-138"
                    cx="91.8652344"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-277"
                    cx="91.8652344"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-69"
                    cx="55.8652344"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-278"
                    cx="55.8652344"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-139"
                    cx="127.865234"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-279"
                    cx="127.865234"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-17"
                    cx="37.8652344"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-590"
                    cx="37.8652344"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-280"
                    cx="37.8652344"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-140"
                    cx="109.865234"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-591"
                    cx="109.865234"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-281"
                    cx="109.865234"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-70"
                    cx="73.8652344"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-592"
                    cx="73.8652344"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-282"
                    cx="73.8652344"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-141"
                    cx="145.865234"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-593"
                    cx="145.865234"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-512"
                    cx="154.865234"
                    cy="10.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-594"
                    cx="154.865234"
                    cy="1.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-283"
                    cx="145.865234"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-513"
                    cx="154.865234"
                    cy="82.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-35"
                    cx="37.8652344"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-284"
                    cx="37.8652344"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-142"
                    cx="109.865234"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-285"
                    cx="109.865234"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-71"
                    cx="73.8652344"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-286"
                    cx="73.8652344"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-143"
                    cx="145.865234"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-514"
                    cx="154.865234"
                    cy="46.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-287"
                    cx="145.865234"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-515"
                    cx="154.865234"
                    cy="118.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-4"
                    cx="15.3652344"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-617"
                    cx="6.36523438"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-595"
                    cx="15.3652344"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-618"
                    cx="6.36523438"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-288"
                    cx="15.3652344"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-619"
                    cx="6.36523438"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-144"
                    cx="87.3652344"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-596"
                    cx="87.3652344"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-289"
                    cx="87.3652344"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-72"
                    cx="51.3652344"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-597"
                    cx="51.3652344"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-290"
                    cx="51.3652344"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-145"
                    cx="123.365234"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-598"
                    cx="123.365234"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-291"
                    cx="123.365234"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-36"
                    cx="15.3652344"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-620"
                    cx="6.36523438"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-292"
                    cx="15.3652344"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-621"
                    cx="6.36523438"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-146"
                    cx="87.3652344"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-293"
                    cx="87.3652344"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-73"
                    cx="51.3652344"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-294"
                    cx="51.3652344"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-147"
                    cx="123.365234"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-295"
                    cx="123.365234"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-18"
                    cx="33.3652344"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-599"
                    cx="33.3652344"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-296"
                    cx="33.3652344"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-148"
                    cx="105.365234"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-600"
                    cx="105.365234"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-297"
                    cx="105.365234"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-74"
                    cx="69.3652344"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-601"
                    cx="69.3652344"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-298"
                    cx="69.3652344"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-149"
                    cx="141.365234"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-602"
                    cx="141.365234"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-299"
                    cx="141.365234"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-37"
                    cx="33.3652344"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-300"
                    cx="33.3652344"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-150"
                    cx="105.365234"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-301"
                    cx="105.365234"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-75"
                    cx="69.3652344"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-302"
                    cx="69.3652344"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-151"
                    cx="141.365234"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-303"
                    cx="141.365234"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-9"
                    cx="24.3652344"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-603"
                    cx="24.3652344"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-304"
                    cx="24.3652344"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-152"
                    cx="96.3652344"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-604"
                    cx="96.3652344"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-305"
                    cx="96.3652344"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-76"
                    cx="60.3652344"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-605"
                    cx="60.3652344"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-306"
                    cx="60.3652344"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-153"
                    cx="132.365234"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-606"
                    cx="132.365234"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-307"
                    cx="132.365234"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-38"
                    cx="24.3652344"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-308"
                    cx="24.3652344"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-154"
                    cx="96.3652344"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-309"
                    cx="96.3652344"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-77"
                    cx="60.3652344"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-310"
                    cx="60.3652344"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-155"
                    cx="132.365234"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-311"
                    cx="132.365234"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-19"
                    cx="42.3652344"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-607"
                    cx="42.3652344"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-312"
                    cx="42.3652344"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-156"
                    cx="114.365234"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-608"
                    cx="114.365234"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-313"
                    cx="114.365234"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-78"
                    cx="78.3652344"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-609"
                    cx="78.3652344"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-314"
                    cx="78.3652344"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-157"
                    cx="150.365234"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-610"
                    cx="150.365234"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-516"
                    cx="159.365234"
                    cy="15.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-611"
                    cx="159.365234"
                    cy="6.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-315"
                    cx="150.365234"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-517"
                    cx="159.365234"
                    cy="87.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-39"
                    cx="42.3652344"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-316"
                    cx="42.3652344"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-158"
                    cx="114.365234"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-317"
                    cx="114.365234"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-79"
                    cx="78.3652344"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-318"
                    cx="78.3652344"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-159"
                    cx="150.365234"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-518"
                    cx="159.365234"
                    cy="51.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-319"
                    cx="150.365234"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-519"
                    cx="159.365234"
                    cy="123.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-2"
                    cx="10.8652344"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-622"
                    cx="1.86523438"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-320"
                    cx="10.8652344"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-623"
                    cx="1.86523438"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-160"
                    cx="82.8652344"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-321"
                    cx="82.8652344"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-80"
                    cx="46.8652344"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-322"
                    cx="46.8652344"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-161"
                    cx="118.865234"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-323"
                    cx="118.865234"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-40"
                    cx="10.8652344"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-624"
                    cx="1.86523438"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-324"
                    cx="10.8652344"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-625"
                    cx="1.86523438"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-162"
                    cx="82.8652344"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-325"
                    cx="82.8652344"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-81"
                    cx="46.8652344"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-326"
                    cx="46.8652344"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-163"
                    cx="118.865234"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-327"
                    cx="118.865234"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-20"
                    cx="28.8652344"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-328"
                    cx="28.8652344"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-164"
                    cx="100.865234"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-329"
                    cx="100.865234"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-82"
                    cx="64.8652344"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-330"
                    cx="64.8652344"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-165"
                    cx="136.865234"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-331"
                    cx="136.865234"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-41"
                    cx="28.8652344"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-332"
                    cx="28.8652344"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-166"
                    cx="100.865234"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-333"
                    cx="100.865234"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-83"
                    cx="64.8652344"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-334"
                    cx="64.8652344"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-167"
                    cx="136.865234"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-335"
                    cx="136.865234"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-10"
                    cx="19.8652344"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-336"
                    cx="19.8652344"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-168"
                    cx="91.8652344"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-337"
                    cx="91.8652344"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-84"
                    cx="55.8652344"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-338"
                    cx="55.8652344"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-169"
                    cx="127.865234"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-339"
                    cx="127.865234"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-42"
                    cx="19.8652344"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-340"
                    cx="19.8652344"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-170"
                    cx="91.8652344"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-341"
                    cx="91.8652344"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-85"
                    cx="55.8652344"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-342"
                    cx="55.8652344"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-171"
                    cx="127.865234"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-343"
                    cx="127.865234"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-21"
                    cx="37.8652344"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-344"
                    cx="37.8652344"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-172"
                    cx="109.865234"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-345"
                    cx="109.865234"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-86"
                    cx="73.8652344"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-346"
                    cx="73.8652344"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-173"
                    cx="145.865234"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-520"
                    cx="154.865234"
                    cy="28.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-347"
                    cx="145.865234"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-521"
                    cx="154.865234"
                    cy="100.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-43"
                    cx="37.8652344"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-348"
                    cx="37.8652344"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-174"
                    cx="109.865234"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-349"
                    cx="109.865234"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-87"
                    cx="73.8652344"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-350"
                    cx="73.8652344"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-175"
                    cx="145.865234"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-522"
                    cx="154.865234"
                    cy="64.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-351"
                    cx="145.865234"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-523"
                    cx="154.865234"
                    cy="136.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-5"
                    cx="15.3652344"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-626"
                    cx="6.36523438"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-352"
                    cx="15.3652344"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-627"
                    cx="6.36523438"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-176"
                    cx="87.3652344"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-353"
                    cx="87.3652344"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-88"
                    cx="51.3652344"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-354"
                    cx="51.3652344"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-177"
                    cx="123.365234"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-355"
                    cx="123.365234"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-44"
                    cx="15.3652344"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-628"
                    cx="6.36523438"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-356"
                    cx="15.3652344"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-629"
                    cx="6.36523438"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-178"
                    cx="87.3652344"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-357"
                    cx="87.3652344"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-89"
                    cx="51.3652344"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-358"
                    cx="51.3652344"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-179"
                    cx="123.365234"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-359"
                    cx="123.365234"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-22"
                    cx="33.3652344"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-360"
                    cx="33.3652344"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-180"
                    cx="105.365234"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-361"
                    cx="105.365234"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-90"
                    cx="69.3652344"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-362"
                    cx="69.3652344"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-181"
                    cx="141.365234"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-363"
                    cx="141.365234"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-45"
                    cx="33.3652344"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-364"
                    cx="33.3652344"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-182"
                    cx="105.365234"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-365"
                    cx="105.365234"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-91"
                    cx="69.3652344"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-366"
                    cx="69.3652344"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-183"
                    cx="141.365234"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-367"
                    cx="141.365234"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-11"
                    cx="24.3652344"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-368"
                    cx="24.3652344"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-184"
                    cx="96.3652344"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-369"
                    cx="96.3652344"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-92"
                    cx="60.3652344"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-370"
                    cx="60.3652344"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-185"
                    cx="132.365234"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-371"
                    cx="132.365234"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-46"
                    cx="24.3652344"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-372"
                    cx="24.3652344"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-186"
                    cx="96.3652344"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-373"
                    cx="96.3652344"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-93"
                    cx="60.3652344"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-374"
                    cx="60.3652344"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-187"
                    cx="132.365234"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-375"
                    cx="132.365234"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-23"
                    cx="42.3652344"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-376"
                    cx="42.3652344"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-188"
                    cx="114.365234"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-377"
                    cx="114.365234"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-94"
                    cx="78.3652344"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-378"
                    cx="78.3652344"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-189"
                    cx="150.365234"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-524"
                    cx="159.365234"
                    cy="33.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-379"
                    cx="150.365234"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-525"
                    cx="159.365234"
                    cy="105.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-47"
                    cx="42.3652344"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-380"
                    cx="42.3652344"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-190"
                    cx="114.365234"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-381"
                    cx="114.365234"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-95"
                    cx="78.3652344"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-382"
                    cx="78.3652344"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-191"
                    cx="150.365234"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-526"
                    cx="159.365234"
                    cy="69.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-383"
                    cx="150.365234"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-527"
                    cx="159.365234"
                    cy="141.17705"
                    r="1.5"
                  />
                  <circle id="Oval-Copy" cx="10.8652344" cy="19.67705" r="1.5" />
                  <circle
                    id="Oval-Copy-630"
                    cx="1.86523438"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-384"
                    cx="10.8652344"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-631"
                    cx="1.86523438"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-192"
                    cx="82.8652344"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-385"
                    cx="82.8652344"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-96"
                    cx="46.8652344"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-386"
                    cx="46.8652344"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-193"
                    cx="118.865234"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-387"
                    cx="118.865234"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-48"
                    cx="10.8652344"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-632"
                    cx="1.86523438"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-388"
                    cx="10.8652344"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-633"
                    cx="1.86523438"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-194"
                    cx="82.8652344"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-389"
                    cx="82.8652344"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-97"
                    cx="46.8652344"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-390"
                    cx="46.8652344"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-195"
                    cx="118.865234"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-391"
                    cx="118.865234"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-24"
                    cx="28.8652344"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-392"
                    cx="28.8652344"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-196"
                    cx="100.865234"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-393"
                    cx="100.865234"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-98"
                    cx="64.8652344"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-394"
                    cx="64.8652344"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-197"
                    cx="136.865234"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-395"
                    cx="136.865234"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-49"
                    cx="28.8652344"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-396"
                    cx="28.8652344"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-198"
                    cx="100.865234"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-397"
                    cx="100.865234"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-99"
                    cx="64.8652344"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-398"
                    cx="64.8652344"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-199"
                    cx="136.865234"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-399"
                    cx="136.865234"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-12"
                    cx="19.8652344"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-400"
                    cx="19.8652344"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-200"
                    cx="91.8652344"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-401"
                    cx="91.8652344"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-100"
                    cx="55.8652344"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-402"
                    cx="55.8652344"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-201"
                    cx="127.865234"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-403"
                    cx="127.865234"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-50"
                    cx="19.8652344"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-404"
                    cx="19.8652344"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-202"
                    cx="91.8652344"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-405"
                    cx="91.8652344"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-101"
                    cx="55.8652344"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-406"
                    cx="55.8652344"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-203"
                    cx="127.865234"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-407"
                    cx="127.865234"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-25"
                    cx="37.8652344"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-408"
                    cx="37.8652344"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-204"
                    cx="109.865234"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-409"
                    cx="109.865234"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-102"
                    cx="73.8652344"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-410"
                    cx="73.8652344"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-205"
                    cx="145.865234"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-528"
                    cx="154.865234"
                    cy="19.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-411"
                    cx="145.865234"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-529"
                    cx="154.865234"
                    cy="91.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-51"
                    cx="37.8652344"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-412"
                    cx="37.8652344"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-206"
                    cx="109.865234"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-413"
                    cx="109.865234"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-103"
                    cx="73.8652344"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-414"
                    cx="73.8652344"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-207"
                    cx="145.865234"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-530"
                    cx="154.865234"
                    cy="55.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-415"
                    cx="145.865234"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-531"
                    cx="154.865234"
                    cy="127.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-6"
                    cx="15.3652344"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-634"
                    cx="6.36523438"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-416"
                    cx="15.3652344"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-635"
                    cx="6.36523438"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-208"
                    cx="87.3652344"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-417"
                    cx="87.3652344"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-104"
                    cx="51.3652344"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-418"
                    cx="51.3652344"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-209"
                    cx="123.365234"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-419"
                    cx="123.365234"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-52"
                    cx="15.3652344"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-636"
                    cx="6.36523438"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-420"
                    cx="15.3652344"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-637"
                    cx="6.36523438"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-210"
                    cx="87.3652344"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-421"
                    cx="87.3652344"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-105"
                    cx="51.3652344"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-422"
                    cx="51.3652344"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-211"
                    cx="123.365234"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-423"
                    cx="123.365234"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-26"
                    cx="33.3652344"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-424"
                    cx="33.3652344"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-212"
                    cx="105.365234"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-425"
                    cx="105.365234"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-106"
                    cx="69.3652344"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-426"
                    cx="69.3652344"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-213"
                    cx="141.365234"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-427"
                    cx="141.365234"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-53"
                    cx="33.3652344"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-428"
                    cx="33.3652344"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-214"
                    cx="105.365234"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-429"
                    cx="105.365234"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-107"
                    cx="69.3652344"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-430"
                    cx="69.3652344"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-215"
                    cx="141.365234"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-431"
                    cx="141.365234"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-13"
                    cx="24.3652344"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-432"
                    cx="24.3652344"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-216"
                    cx="96.3652344"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-433"
                    cx="96.3652344"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-108"
                    cx="60.3652344"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-434"
                    cx="60.3652344"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-217"
                    cx="132.365234"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-435"
                    cx="132.365234"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-54"
                    cx="24.3652344"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-436"
                    cx="24.3652344"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-218"
                    cx="96.3652344"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-437"
                    cx="96.3652344"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-109"
                    cx="60.3652344"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-438"
                    cx="60.3652344"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-219"
                    cx="132.365234"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-439"
                    cx="132.365234"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-27"
                    cx="42.3652344"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-440"
                    cx="42.3652344"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-220"
                    cx="114.365234"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-441"
                    cx="114.365234"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-110"
                    cx="78.3652344"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-442"
                    cx="78.3652344"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-221"
                    cx="150.365234"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-532"
                    cx="159.365234"
                    cy="24.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-443"
                    cx="150.365234"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-533"
                    cx="159.365234"
                    cy="96.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-55"
                    cx="42.3652344"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-444"
                    cx="42.3652344"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-222"
                    cx="114.365234"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-445"
                    cx="114.365234"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-111"
                    cx="78.3652344"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-446"
                    cx="78.3652344"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-223"
                    cx="150.365234"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-534"
                    cx="159.365234"
                    cy="60.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-447"
                    cx="150.365234"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-535"
                    cx="159.365234"
                    cy="132.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-3"
                    cx="10.8652344"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-638"
                    cx="1.86523438"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-448"
                    cx="10.8652344"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-639"
                    cx="1.86523438"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-224"
                    cx="82.8652344"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-449"
                    cx="82.8652344"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-112"
                    cx="46.8652344"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-450"
                    cx="46.8652344"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-225"
                    cx="118.865234"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-451"
                    cx="118.865234"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-56"
                    cx="10.8652344"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-640"
                    cx="1.86523438"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-452"
                    cx="10.8652344"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-641"
                    cx="1.86523438"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-544"
                    cx="10.8652344"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-642"
                    cx="1.86523438"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-226"
                    cx="82.8652344"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-453"
                    cx="82.8652344"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-545"
                    cx="82.8652344"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-113"
                    cx="46.8652344"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-454"
                    cx="46.8652344"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-546"
                    cx="46.8652344"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-227"
                    cx="118.865234"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-455"
                    cx="118.865234"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-547"
                    cx="118.865234"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-28"
                    cx="28.8652344"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-456"
                    cx="28.8652344"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-228"
                    cx="100.865234"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-457"
                    cx="100.865234"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-114"
                    cx="64.8652344"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-458"
                    cx="64.8652344"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-229"
                    cx="136.865234"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-459"
                    cx="136.865234"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-57"
                    cx="28.8652344"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-460"
                    cx="28.8652344"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-548"
                    cx="28.8652344"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-230"
                    cx="100.865234"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-461"
                    cx="100.865234"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-549"
                    cx="100.865234"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-115"
                    cx="64.8652344"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-462"
                    cx="64.8652344"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-550"
                    cx="64.8652344"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-231"
                    cx="136.865234"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-463"
                    cx="136.865234"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-551"
                    cx="136.865234"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-14"
                    cx="19.8652344"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-464"
                    cx="19.8652344"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-232"
                    cx="91.8652344"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-465"
                    cx="91.8652344"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-116"
                    cx="55.8652344"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-466"
                    cx="55.8652344"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-233"
                    cx="127.865234"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-467"
                    cx="127.865234"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-58"
                    cx="19.8652344"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-468"
                    cx="19.8652344"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-552"
                    cx="19.8652344"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-234"
                    cx="91.8652344"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-469"
                    cx="91.8652344"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-553"
                    cx="91.8652344"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-117"
                    cx="55.8652344"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-470"
                    cx="55.8652344"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-554"
                    cx="55.8652344"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-235"
                    cx="127.865234"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-471"
                    cx="127.865234"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-555"
                    cx="127.865234"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-29"
                    cx="37.8652344"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-472"
                    cx="37.8652344"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-236"
                    cx="109.865234"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-473"
                    cx="109.865234"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-118"
                    cx="73.8652344"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-474"
                    cx="73.8652344"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-237"
                    cx="145.865234"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-536"
                    cx="154.865234"
                    cy="37.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-475"
                    cx="145.865234"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-537"
                    cx="154.865234"
                    cy="109.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-59"
                    cx="37.8652344"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-476"
                    cx="37.8652344"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-556"
                    cx="37.8652344"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-238"
                    cx="109.865234"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-477"
                    cx="109.865234"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-557"
                    cx="109.865234"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-119"
                    cx="73.8652344"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-478"
                    cx="73.8652344"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-558"
                    cx="73.8652344"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-239"
                    cx="145.865234"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-538"
                    cx="154.865234"
                    cy="73.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-479"
                    cx="145.865234"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-559"
                    cx="145.865234"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-539"
                    cx="154.865234"
                    cy="145.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-560"
                    cx="154.865234"
                    cy="154.67705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-7"
                    cx="15.3652344"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-643"
                    cx="6.36523438"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-480"
                    cx="15.3652344"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-644"
                    cx="6.36523438"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-240"
                    cx="87.3652344"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-481"
                    cx="87.3652344"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-120"
                    cx="51.3652344"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-482"
                    cx="51.3652344"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-241"
                    cx="123.365234"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-483"
                    cx="123.365234"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-60"
                    cx="15.3652344"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-645"
                    cx="6.36523438"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-484"
                    cx="15.3652344"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-646"
                    cx="6.36523438"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-561"
                    cx="15.3652344"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-647"
                    cx="6.36523438"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-242"
                    cx="87.3652344"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-485"
                    cx="87.3652344"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-562"
                    cx="87.3652344"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-121"
                    cx="51.3652344"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-486"
                    cx="51.3652344"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-563"
                    cx="51.3652344"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-243"
                    cx="123.365234"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-487"
                    cx="123.365234"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-564"
                    cx="123.365234"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-30"
                    cx="33.3652344"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-488"
                    cx="33.3652344"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-244"
                    cx="105.365234"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-489"
                    cx="105.365234"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-122"
                    cx="69.3652344"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-490"
                    cx="69.3652344"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-245"
                    cx="141.365234"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-491"
                    cx="141.365234"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-61"
                    cx="33.3652344"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-492"
                    cx="33.3652344"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-565"
                    cx="33.3652344"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-246"
                    cx="105.365234"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-493"
                    cx="105.365234"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-566"
                    cx="105.365234"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-123"
                    cx="69.3652344"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-494"
                    cx="69.3652344"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-567"
                    cx="69.3652344"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-247"
                    cx="141.365234"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-495"
                    cx="141.365234"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-568"
                    cx="141.365234"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-15"
                    cx="24.3652344"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-496"
                    cx="24.3652344"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-248"
                    cx="96.3652344"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-497"
                    cx="96.3652344"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-124"
                    cx="60.3652344"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-498"
                    cx="60.3652344"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-249"
                    cx="132.365234"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-499"
                    cx="132.365234"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-62"
                    cx="24.3652344"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-500"
                    cx="24.3652344"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-569"
                    cx="24.3652344"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-250"
                    cx="96.3652344"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-501"
                    cx="96.3652344"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-570"
                    cx="96.3652344"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-125"
                    cx="60.3652344"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-502"
                    cx="60.3652344"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-571"
                    cx="60.3652344"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-251"
                    cx="132.365234"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-503"
                    cx="132.365234"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-572"
                    cx="132.365234"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-31"
                    cx="42.3652344"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-504"
                    cx="42.3652344"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-252"
                    cx="114.365234"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-505"
                    cx="114.365234"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-126"
                    cx="78.3652344"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-506"
                    cx="78.3652344"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-253"
                    cx="150.365234"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-540"
                    cx="159.365234"
                    cy="42.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-507"
                    cx="150.365234"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-541"
                    cx="159.365234"
                    cy="114.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-63"
                    cx="42.3652344"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-508"
                    cx="42.3652344"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-573"
                    cx="42.3652344"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-254"
                    cx="114.365234"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-509"
                    cx="114.365234"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-574"
                    cx="114.365234"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-127"
                    cx="78.3652344"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-510"
                    cx="78.3652344"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-575"
                    cx="78.3652344"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-255"
                    cx="150.365234"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-542"
                    cx="159.365234"
                    cy="78.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-511"
                    cx="150.365234"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-576"
                    cx="150.365234"
                    cy="159.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-543"
                    cx="159.365234"
                    cy="150.17705"
                    r="1.5"
                  />
                  <circle
                    id="Oval-Copy-577"
                    cx="159.365234"
                    cy="159.17705"
                    r="1.5"
                  />
                </g>
              </g>
            </g>
            <g id="Hand" transform="translate(0.000000, 8.000000)">
              <path
                d="M156.276459,100.039944 C157.593876,108.03566 161.675692,129.833677 153.239455,142.271917 C127.519246,180.190931 99.580884,174.09101 88.3004361,165.702453 C59.9101514,144.591649 27.8993022,113.989431 27.8993022,113.989431 L25.9195488,112.010714 C22.1559445,108.246073 22.1559445,102.143043 25.9195488,98.378402 L25.9205854,98.378402 C29.5090178,94.7910061 35.2648138,94.5982133 39.0843902,97.9409906 L66.7231978,122.125077 C67.1481711,122.497187 67.7877039,122.475421 68.1857276,122.07636 C68.6044818,121.658643 68.6044818,120.980759 68.1857276,120.562005 L22.0357081,74.411985 C17.9880973,70.3643742 17.9880973,63.8011291 22.0357081,59.7535182 C26.0843555,55.7059074 32.6465641,55.7059074 36.6941749,59.7535182 L76.2488173,99.3081605 C76.6665348,99.7258781 77.344419,99.7258781 77.7621365,99.3081605 C78.1611968,98.9091003 78.1819272,98.2685309 77.80878,97.8445942 L31.4379817,45.122001 C27.8526588,41.0453675 28.2144043,34.8428314 32.2495769,31.2108651 C36.3220642,27.5467667 42.5950837,27.8805261 46.2539995,31.9581961 L90.1765374,80.8995641 C90.5869993,81.3566695 91.2970156,81.3763634 91.7313175,80.9410249 C92.1117204,80.5606221 92.1511081,79.9563309 91.8214947,79.5292846 L59.552552,37.6984442 C55.8480293,32.8972833 56.7871165,25.9940596 61.6380304,22.3558742 C66.4702869,18.7311635 73.3310133,19.7396975 76.9163362,24.6020132 L118.383358,77.9112768 C120.263605,80.5150152 130.387297,82.9736408 132.267544,73.2832147 C133.992314,64.3950551 135.015359,57.4016542 141.052052,50.5637313 C147.809126,42.9090306 156.372855,43.9237838 159.071953,45.4028979 C163.037679,47.5764805 164.328147,53.596589 161.416562,57.0575295 C158.455224,60.5765152 155.273107,65.4077352 154.541324,70.5354 C153.094342,80.6590915 156.276459,100.039944 156.276459,100.039944 Z"
                id="Filled"
                fill={themeContext.colors.primaryShades[100]}
              />
              <path
                d="M153.2762,92.0398597 C154.5922,100.03586 158.6742,121.83386 150.2392,134.27186 C124.5192,172.19086 96.5812,166.09086 85.2992,157.70286 C56.9102,136.59186 24.8992,105.98986 24.8992,105.98986 L22.9202,104.01086 C19.1562,100.24686 19.1562,94.1438597 22.9202,90.3788597 C26.5072,86.7908597 32.2642,86.5988597 36.0842,89.9408597 L63.7232,114.12486 C64.1482,114.49786 64.7882,114.47586 65.1852,114.07686 C65.6042,113.65886 65.6042,112.98086 65.1852,112.56186 L19.0362,66.4118597 C14.9882,62.3648597 14.9882,55.8008597 19.0362,51.7538597 C23.0842,47.7058597 29.6462,47.7058597 33.6942,51.7538597 L73.2492,91.3088597 C73.6672,91.7258597 74.3432,91.7258597 74.7602,91.3088597 C75.1612,90.9098597 75.1812,90.2688597 74.8082,89.8448597 L28.4382,37.1228597 C24.8522,33.0458597 25.2142,26.8428597 29.2502,23.2108597 C33.3222,19.5468597 39.5932,19.8808597 43.2542,23.9578597 L87.1752,72.8998597 C87.5872,73.3568597 88.2972,73.3758597 88.7312,72.9408597 C89.1112,72.5608597 89.1512,71.9568597 88.8212,71.5298597 L56.5512,29.6988597 C52.8472,24.8968597 53.7872,17.9938597 58.6362,14.3558597 C63.4692,10.7308597 70.3312,11.7398597 73.9162,16.6018597 L115.3822,69.9118597 C117.2632,72.5148597 127.3862,74.9738597 129.2672,65.2838597 C130.9922,56.3948597 132.0152,49.4018597 138.0502,42.5638597 C144.8092,34.9088597 153.3732,35.9238597 156.0722,37.4028597 C160.0382,39.5768597 161.3282,45.5968597 158.4172,49.0578597 C155.4552,52.5768597 152.2732,57.4078597 151.5412,62.5358597 C150.0932,72.6588597 153.2762,92.0398597 153.2762,92.0398597 Z M29.7382,90.5618597 C28.0312,90.5618597 26.3292,91.2128597 25.0412,92.4998597 C22.4532,95.0888597 22.4532,99.3018597 25.0412,101.88986 L27.0202,103.86886 C27.2912,104.12586 59.1792,134.54086 87.0892,155.29586 C89.4792,157.07186 98.2752,162.69886 111.2122,160.50886 C124.2232,158.30586 136.8602,148.65086 147.7562,132.58786 C155.1762,121.64586 151.8922,101.97086 150.4892,93.5688597 L150.3162,92.5258597 C150.1822,91.7158597 147.0762,72.5698597 148.5712,62.1108597 C149.2572,57.3048597 151.7972,52.2628597 156.1222,47.1258597 C156.8852,46.2178597 157.1722,44.8778597 156.9042,43.4518597 C156.6212,41.9368597 155.7702,40.6588597 154.6302,40.0338597 C153.4832,39.4048597 146.3802,37.6628597 140.2992,44.5488597 C135.1872,50.3408597 134.0742,56.1498597 132.5322,64.1888597 L132.2122,65.8558597 C130.9222,72.5058597 126.5322,74.4228597 124.0302,74.9748597 C119.9202,75.8798597 114.9882,74.4218597 112.9882,71.7198597 L71.5472,18.4438597 C70.2462,16.6798597 68.4012,15.5718597 66.3072,15.2648597 C64.2142,14.9568597 62.1292,15.4858597 60.4362,16.7558597 C58.7382,18.0298597 57.6442,19.8918597 57.3582,21.9968597 C57.0732,24.1008597 57.6302,26.1858597 58.9262,27.8668597 L91.1962,69.6978597 C92.4432,71.3098597 92.2972,73.6168597 90.8542,75.0608597 C90.0672,75.8488597 88.9482,76.2868597 87.8672,76.2538597 C86.7552,76.2248597 85.6902,75.7338597 84.9462,74.9078597 L41.0212,25.9618597 C39.7872,24.5868597 38.0912,23.7758597 36.2472,23.6778597 C34.3972,23.5778597 32.6302,24.2058597 31.2562,25.4408597 C28.4562,27.9608597 28.2022,32.3128597 30.6902,35.1408597 L77.0602,87.8638597 C78.4762,89.4738597 78.3972,91.9208597 76.8782,93.4338597 C75.2972,95.0148597 72.7172,95.0158597 71.1302,93.4328597 L31.5732,53.8748597 C30.1812,52.4838597 28.3322,51.7178597 26.3652,51.7178597 C24.3982,51.7178597 22.5482,52.4838597 21.1572,53.8748597 C19.7662,55.2668597 19.0002,57.1158597 19.0002,59.0828597 C19.0002,61.0508597 19.7662,62.8998597 21.1572,64.2898597 L67.3052,110.44086 C68.0762,111.20986 68.4992,112.23386 68.4992,113.32186 C68.4982,114.40986 68.0732,115.43286 67.3032,116.20086 C65.8032,117.70986 63.3582,117.79386 61.7462,116.38086 L34.1082,92.1988597 C32.8572,91.1038597 31.2962,90.5618597 29.7382,90.5618597 Z M97.3193001,3.36006317 L99.0614374,0.917736833 L99.3563188,1.12808106 C111.683747,9.95006954 120.41773,22.9208581 123.953964,37.6579019 L121.036773,38.3578981 C117.668976,24.322809 109.35088,11.9696509 97.6123001,3.56906317 L97.3193001,3.36006317 Z M90.3398001,13.1217632 L92.0819374,10.6794368 L92.3767981,10.8897663 C102.354237,18.0297548 109.422244,28.5275628 112.284477,40.4576549 L109.36726,41.1575451 C106.673442,29.9294249 100.021323,20.0493182 90.6328001,13.3307632 L90.3398001,13.1217632 Z M32.3288998,148.666569 L31.0342377,151.372831 L30.7097543,151.217599 C17.0380245,144.671108 6.18414577,133.413503 0.142900803,119.514645 L2.8942367,118.318755 C8.64770718,131.555543 18.9847319,142.277068 32.0048998,148.511569 L32.3288998,148.666569 Z M37.5075998,137.841369 L36.2129377,140.547631 L35.8884214,140.392384 C24.8226216,135.09337 16.0383654,125.982191 11.1476056,114.730456 L13.8989319,113.534544 C18.5019259,124.124243 26.7693587,132.699363 37.1835998,137.686369 L37.5075998,137.841369 Z"
                id="Combined-Shape"
                fill={themeContext.colors.primaryShades[600]}
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
};
export { PermIdentity, Chevron, MousePointerIllustration, WelcomeBack };
